import { createApp } from "vue";
import { createPinia } from "pinia";
import PrimeVue from "primevue/config";

import { createI18n } from "vue-i18n";

import App from "./App.vue";
import router from "./router";

// import Tooltip from "primevue/tooltip";
// import Button from "primevue/button";
// import InputText from "primevue/inputtext";
// import Textarea from "primevue/textarea";
// import FileUpload from "primevue/fileupload";
// import MainArea from "@/layout/MainArea.vue";
// import LeftBar from "@/layout/LeftBar.vue";
// import RightBar from "@/layout/RightBar.vue";
// import Dropdown from "primevue/dropdown";
import ToastService from "primevue/toastservice";
import ConfirmationService from "primevue/confirmationservice";
// import Toast from "primevue/toast";
// import Panel from "@/components/common/Panel.vue";
// import Input from "@/components/common/form/Input.vue";
// import NumberInput from "@/components/common/form/NumberInput.vue";
// import Select from "@/components/common/form/Select.vue";
// import Tag from "primevue/tag";
//
import * as Sentry from "@sentry/vue";

//CSS
import "primevue/resources/themes/arya-blue/theme.css"; // core css
import "primeflex/primeflex.css";
import "primeicons/primeicons.css";

import "./assets/main_theme.scss";
import "./assets/zs_theme.scss"; // icons
import "./assets/zs-styles/zslic.css"; // icons

import validationRules from "./plugins/i18n-v-rules.js";
import directivesPlugin from './plugins/directives'
import tooltipPlugin from './plugins/tooltip';
import zsGlobalComponents from './plugins/zs-global-components.js';

async function loadJSON(path) {
  const response = await fetch(path);
  return await response.json();
}

const hash = "?hash=" + _APP_COMMIT_HASH_;
const [en, pt, es, fr] = await Promise.all([
  loadJSON("/translation-en.json" + hash),
  loadJSON("/translation-pt.json" + hash),
  loadJSON("/translation-es.json" + hash),
  loadJSON("/translation-fr.json" + hash),
]);
const translation = { en, pt, es, fr };

const crules = await loadJSON("/country_rules.json");

// const translationLocal = await loadJSON('/translation.json')
// const system = await loadJSON('/system_messages.json')

// const translation = {
//     pt: { ...translationLocal.pt, ...system.pt },
//     en: { ...translationLocal.en, ...system.en },
//     es: { ...translationLocal.es, ...system.es }
// }

// const translation = {
//     pt: { ...translationLocal.pt, syste12345m: { ...system.pt } },
//     en: { ...translationLocal.en, system: { ...system.en } },
//     es: { ...translationLocal.es, system: { ...system.es } }
// }

// 2. Create i18n instance with options
const i18n = createI18n({
  legacy: false,
  locale: "pt", // set locale
  fallbackLocale: "pt", // set fallback locale
  messages: translation, // set locale messages
  // If you need to specify other options, you can set other options
  // ...
});

const app = createApp(App);

Sentry.init({
  app,
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.VITE_SENTRY_ENVIRONMENT,
  // Versão da app (VITE_APP_VERSION no .env, equivalente ao LOG_APP_VERSION do
  // zslic-be) + commit do build, para identificar o release nos eventos Sentry.
  release: `zslic-fe@${import.meta.env.VITE_APP_VERSION || "0.0"}+${_APP_COMMIT_HASH_.trim()}`,
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
  // Chunk obsoleto após deploy (Vite): erro transitório, já tratado com reload no
  // handler vite:preloadError. "Importing a module script failed" é a variante do Safari.
  ignoreErrors: [
    /Failed to fetch dynamically imported module/,
    /Importing a module script failed/,
  ],
  beforeSend(event, hint) {
    // 401/403 nos endpoints de autenticação (/v1/auth/* — login, change-password,
    // recover-password, SSO) são esperados (ex.: credenciais erradas) e já tratados
    // na app (toast + redirect para /login) — não são crashes. Filtram-se só estes
    // para reduzir ruído, mantendo visibilidade de 401/403 anómalos noutros endpoints.
    const err = hint?.originalException;
    const status = err?.response?.status ?? err?.status;
    const url = err?.config?.url ?? "";
    const isAuthEndpoint = url.includes("/auth/");
    if ((status === 401 || status === 403) && isAuthEndpoint) {
      return null; // descarta o evento
    }
    return event;
  }
});

app.use(validationRules, crules);

app.use(createPinia());
app.use(i18n);
import "./services/axios.interceptor.js";
app.use(PrimeVue, { ripple: true });
app.use(ToastService);
app.use(ConfirmationService);
app.use(router);
app.use(directivesPlugin);
app.use(zsGlobalComponents);

// app.component("Button", Button);
// app.component("InputText", InputText);
// app.component("Textarea", Textarea);
// app.component("FileUpload", FileUpload);
// app.directive("tooltip", Tooltip);
app.use(tooltipPlugin);
// app.component("MainArea", MainArea);
// app.component("LeftBar", LeftBar);
// app.component("RightBar", RightBar);
// app.component("Panel", Panel);
// app.component("Dropdown", Dropdown);
// app.component("Toast", Toast);
// app.component("TextInput", Input);
// app.component("SelectInput", Select);
// app.component("Tag", Tag);
// app.component("NumberInput", NumberInput);

app.mount("#app");

window.addEventListener('vite:preloadError', (event) => {
  // Chunk obsoleto após deploy: o hash do asset mudou e o import() do antigo dá 404.
  // preventDefault() impede o Vite de relançar o erro (deixa de ir ao Sentry como crash).
  event.preventDefault();
  console.warn('Preload error detected, reloading...', event.payload);
  const KEY = 'vite:preloadError:lastReload';
  const last = Number(sessionStorage.getItem(KEY) || 0);
  if (Date.now() - last < 10000) return; // recarregou há <10s → provável loop, aborta
  sessionStorage.setItem(KEY, String(Date.now()));
  window.location.reload();
});
